import * as React from 'react';
import type { ToolProps } from './types.js'

export function Tool(_: ToolProps) {
  return null
}
